import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Rellax from "rellax";
@Component
export class RellaxBlock extends ThemeComponent {
    @Prop({ default: 2 }) speed!: number;
    @Prop({ default: true }) center!: boolean;
    @Prop({ default: false }) round!: boolean;
    @Prop({ default: true }) vertical!: boolean;
    @Prop({ default: false }) horizontal!: boolean;
    @Prop({ default: false }) desktopOnly!: boolean;
    options = {};
    init() {
        this.options = Object.assign(
            {
                speed: this.speed,
                center: this.center,
                round: this.round,
                vertical: this.vertical,
                horizontal: this.horizontal
            }
        );
        this.rellaxit();
        window.addEventListener('resize', () => this.rellaxit());
    }
    rellaxit(rellax?: Rellax.RellaxInstance | undefined) {
        if (rellax) {
            rellax.destroy();
            this.removeAttribute('style');
        }
        if (this.desktopOnly) {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                const relax = Rellax(this, this.options);
                window.addEventListener('resize', () => this.rellaxit(relax));
            }
        } else {
            const relax = Rellax(this, this.options);
            window.addEventListener('resize', () => this.rellaxit(relax));
        }
    }
}
